export default __webpack_public_path__ + "static/nena-229db4a37e122e7235834b0f3fc02d02.jpg";